import React from "react";

/*eslint-disable */

interface DescriptionComponentProps {
  politicas: any;
}

declare const window: any;
const DescriptionComponent: React.FC<DescriptionComponentProps> = ({politicas}) => {
  return (
    <div className="container w-80" dangerouslySetInnerHTML={{ __html: politicas?.content }}>
    </div>
  );
};

export default DescriptionComponent;
